import request from '@/API/request';

// 获取政务服务服务入口
export function getServicesEntryList(pageKey = 'governmentPage') {
  return request({
    url: `resource/api/ad/page/${pageKey}`,
    method: 'get',
  });
}

// 查询文章
export function getServiceContent(id) {
  return request({
    url: `resource/api/article/${id}`,
    method: 'get',
  });
}

/** *   碳足迹   * **/
export function getCarbonFootprint(pageKey = 'carbonFootprint') {
  return request({
    url: `resource/api/ad/page/${pageKey}`,
    method: 'get',
  });
}
